import { connect } from "react-redux";
import Onboarding from "../onboarding";

import "./style.css";

function ProgramIntro(props) {
    const { account } = props.User;
    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];
    const programsInWP = onboardingDetail?.programs?.split(",");

    const programIsFull = programsInWP?.length >= 3;

    return (
        <>
            <div id="program-intro-v2" className={`${programIsFull ? "programs-full" : ""}`}>
                <Onboarding programIsFull={programIsFull} />
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
})(ProgramIntro);
